module.exports = __webpack_public_path__ + "img/A.44afbf0f.png";